// document.querySelectorAll('.boxes__item-head').forEach(item => {
//   item.addEventListener('click', function (event) {
//     // event.stopPropagation();
//     item.closest('.boxes__item').classList.toggle('opened');
//   });
// });
document.querySelectorAll('.boxes__item-actions').forEach(function (item) {
  item.addEventListener('click', function (event) {
    // event.stopPropagation();
    item.classList.toggle('opened');
  });
  item.querySelector('ul').addEventListener('click', function (event) {// event.stopPropagation();
  });
});